module.exports = __webpack_public_path__ + "img/hatchet-icon.94f37b50.jpg";